import React from "react";

const QuranAudioDock = ({
  commandsVisible,
  uiLabels,
  recitationCurrentReaderLabel,
  recitationCurrentChapterLabel,
  recitationCurrentVerseKey,
  onHide,
  onStop,
  recitationCurrentTime,
  recitationProgressPercent,
  onSeek,
  recitationDuration,
  canRecitationPrev,
  onPrevious,
  recitationIsPlaying,
  onTogglePlayPause,
  recitationSessionActive,
  recitationCurrentAudioUrl,
  canRecitationNext,
  onNext,
  onToggleRate,
  recitationRate,
  formatTime,
}) => {
  return (
    <div
      className={`quran-audio-dock ${commandsVisible ? "quran-audio-dock--with-commands" : ""}`}
      dir="ltr"
      onClick={(event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
    >
      <div className="quran-audio-dock-head">
        <button
          type="button"
          className="quran-audio-icon-btn quran-audio-close"
          aria-label={uiLabels.hideAudioDock}
          title={uiLabels.hide}
          onClick={onHide}
        >
          <span className="quran-icon-glyph">✕</span>
        </button>

        <div className="quran-audio-main-meta">
          <div className="quran-audio-reader">{recitationCurrentReaderLabel || uiLabels.recitation}</div>
          <div className="quran-audio-verse">{recitationCurrentChapterLabel || recitationCurrentVerseKey}</div>
        </div>

        <button
          type="button"
          className="quran-audio-icon-btn"
          aria-label={uiLabels.stop}
          title={uiLabels.stop}
          onClick={onStop}
        >
          <span className="quran-icon-glyph">◼</span>
        </button>
      </div>

      <div className="quran-audio-progress-wrap">
        <span>{formatTime(recitationCurrentTime)}</span>
        <input
          type="range"
          min={0}
          max={100}
          step={0.1}
          value={recitationProgressPercent}
          onChange={(event) => onSeek((Number(event.target.value) || 0) / 100)}
          aria-label={uiLabels.audioProgress}
        />
        <span>-{formatTime(Math.max(0, recitationDuration - recitationCurrentTime))}</span>
      </div>

      <div className="quran-audio-dock-controls">
        <button
          type="button"
          className="quran-audio-icon-btn"
          aria-label={uiLabels.previous}
          title={uiLabels.previous}
          onClick={onPrevious}
          disabled={!canRecitationPrev}
        >
          <i className="bi bi-skip-backward-fill quran-audio-skip-icon" aria-hidden="true" />
        </button>
        <button
          type="button"
          className="quran-audio-icon-btn quran-audio-primary"
          aria-label={recitationIsPlaying ? uiLabels.pause : uiLabels.play}
          title={recitationIsPlaying ? uiLabels.pause : uiLabels.play}
          onClick={onTogglePlayPause}
          disabled={!recitationSessionActive || !recitationCurrentAudioUrl}
        >
          <i className={`bi ${recitationIsPlaying ? "bi-pause-fill" : "bi-play-fill"} quran-audio-play-icon`} aria-hidden="true" />
        </button>
        <button
          type="button"
          className="quran-audio-icon-btn"
          aria-label={uiLabels.next}
          title={uiLabels.next}
          onClick={onNext}
          disabled={!canRecitationNext}
        >
          <i className="bi bi-skip-forward-fill quran-audio-skip-icon" aria-hidden="true" />
        </button>
        <button
          type="button"
          className="quran-audio-icon-btn quran-audio-rate"
          aria-label={uiLabels.speed}
          title={uiLabels.speed}
          onClick={onToggleRate}
        >
          {Number(recitationRate).toFixed(recitationRate % 1 === 0 ? 0 : 2)}x
        </button>
      </div>
    </div>
  );
};

export default QuranAudioDock;
